// extracted by mini-css-extract-plugin
export var integrationButton = "_96-0";